"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dismiss = exports.show = exports.DISMISS_SNACKBAR = exports.SHOW_SNACKBAR = void 0;
var ROOT = '@@snackbar';
var SHOW_SNACKBAR = "".concat(ROOT, "/SHOW_SNACKBAR");
exports.SHOW_SNACKBAR = SHOW_SNACKBAR;
var DISMISS_SNACKBAR = "".concat(ROOT, "/DISMISS_SNACKBAR");
exports.DISMISS_SNACKBAR = DISMISS_SNACKBAR;

var show = function show(payload) {
  return {
    type: SHOW_SNACKBAR,
    payload: payload
  };
};

exports.show = show;

var dismiss = function dismiss(id) {
  return {
    type: DISMISS_SNACKBAR,
    id: id
  };
};

exports.dismiss = dismiss;